import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useGetSettingFinancialStatement from '../../../companyAnalysis/financial/common/useGetSettingFinancialStatement'
import { getInnerHeight } from '../../../helpers/device'
import { Element } from '../../html/element'
import { Loading } from '../../loading'
import { Notification } from '../../notification'
import { ScrollComponent } from '../../scrollComponent'
import { ActionButton } from './actionButton'
import { factSheetTypes } from './constants'
import { FactSheetContent } from './factSheetContent'
import { FactSheetFooter } from './factSheetFooter'
import './i18n'
import classes from './index.module.scss'
import {
  changeFsType,
  changeSource,
  resetStore,
  selectData,
  selectIsLoading,
} from './store/slice'
import { getDataAvailability, getReportItem } from './store/thunk'
import useGetOrganizationId from './useGetOrganizationId'

export const Content = ({ type }) => {
  const dispatch = useDispatch()

  const organizationId = useGetOrganizationId()

  const settingFinancialAnalysis = useGetSettingFinancialStatement()

  const isLoading = useSelector(selectIsLoading)
  const data = useSelector(selectData)

  useEffect(() => {
    dispatch(
      getReportItem({
        OrganizationId: organizationId,
      }),
    )
    dispatch(changeSource(settingFinancialAnalysis.sourceOrganizationId))
    dispatch(changeFsType(settingFinancialAnalysis.isConsolidated))
    dispatch(
      getDataAvailability({
        organizationId,
        ...settingFinancialAnalysis,
      }),
    )
  }, [])

  useEffect(() => {
    return () => {
      dispatch(resetStore())
    }
  }, [])

  if (isLoading) {
    return (
      <div className="positionRelative" style={{ height: 200 }}>
        <Loading />
      </div>
    )
  }

  if (!Object.keys(data).length || !data.dataBlocks?.length) {
    return (
      <div style={{ height: 200 }}>
        <Notification />
      </div>
    )
  }

  if (type === factSheetTypes.PREVIEW) {
    return (
      <div
        className={classes.content}
        style={{ padding: 12, backgroundColor: '#F3F3F3' }}
      >
        <FactSheetContent type={type} />
        <Element
          className={classes.divider}
          style={{ borderTop: '1px dashed #d7d7d7' }}
        />
        <FactSheetFooter type={type} />
        <ActionButton data={data} />
      </div>
    )
  }

  return (
    <>
      <ScrollComponent autoHeight autoHeightMax={getInnerHeight() - 200}>
        <div className={classes.content}>
          <FactSheetContent type={type} />
          <FactSheetFooter type={type} />
        </div>
      </ScrollComponent>
      <ActionButton data={data} />
    </>
  )
}
